import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, map, switchMap } from 'rxjs';

import {
    AUTHORITIES_URLS,
    CIP_ADMIN_ENDPOINT,
    ConfigurationService,
    InfraPreset,
    Logger
} from '@mobi/rwc-utils-common-ng-jslib';

import { ACCESS_TOKEN_PROVIDER } from '../access-token.provider';

import { AUTHORIZATION_HEADER, AccessTokenErrorHandlerService } from './access-token-error-handler.service';

const IGNORED_URLS = [...AUTHORITIES_URLS];

export const accessTokenInterceptor: HttpInterceptorFn = (req, next) => {
    if (IGNORED_URLS.some(ignoredUrl => req.url.includes(ignoredUrl)) && !req.url.includes(CIP_ADMIN_ENDPOINT)) {
        return next(req);
    }
    const logger = inject(Logger).createCustomLogger('AccessTokenInterceptor');
    const infraPreset = inject(ConfigurationService).getSync('infraPreset') as InfraPreset;
    const errorHandler = inject(AccessTokenErrorHandlerService);

    return inject(ACCESS_TOKEN_PROVIDER).accessTokenOnce$.pipe(
        map(accessToken => {
            if (accessToken) {
                return req.clone({
                    setHeaders: {
                        [AUTHORIZATION_HEADER]: `Bearer ${accessToken}`
                    }
                });
            } else if (infraPreset === 'b2e' || infraPreset === 'b2eadmin') {
                logger.error(`No access token available to set '${AUTHORIZATION_HEADER}' header`);
            }
            return req;
        }),
        switchMap(request =>
            next(request).pipe(
                catchError((errorResponse: HttpErrorResponse) =>
                    errorHandler.handleAccessTokenError(errorResponse, request)
                )
            )
        )
    );
};
